import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Painel } from '../models/painel';
import { Result } from '../models/result';

@Injectable({ providedIn: 'root' })
export class PainelService {
  apiUrl = environment.urlControlCenterApi + 'painel';

  constructor(private http: HttpClient) {}

  getAll(localId: number) {
    const queryParams = [];

    if (localId != null) {
      queryParams.push(`?localId=${localId}`);
    }

    const fullUrl = this.apiUrl + queryParams;

    const headers = new HttpHeaders({
      'Ignore-Loading': 'true',
    });

    return this.http.get<Result<Painel[]>>(fullUrl, { headers });
  }
}
